// removed by extract-text-webpack-plugin
module.exports = {"item-dropdown":"ServiceCardFooterOptions__item-dropdown___2Xd4e"};